//#region src/extensions/text-style-extension/utils/unset-text-style-attribute.ts
var e = (e, t, n, r) => {
	let { selection: i } = t, { from: a, to: o } = i, s = [];
	return t.doc.nodesBetween(a, o, (t, n) => {
		t.isText && t.marks.forEach((r) => {
			r.type.name === "textStyle" && r.attrs[e] && s.push({
				mark: r,
				pos: n,
				size: t.nodeSize
			});
		});
	}), s.forEach(({ mark: r, pos: i, size: s }) => {
		let c = {
			...r.attrs,
			[e]: null
		}, l = Math.max(a, i), u = Math.min(o, i + s);
		if (n.removeMark(l, u, r.type), Object.entries(c).some(([t, n]) => t !== e && n != null)) {
			let e = t.schema.marks.textStyle;
			if (e) {
				let t = e.create(c);
				n.addMark(l, u, t);
			}
		}
	}), r && r(n), !0;
};
//#endregion
export { e as unsetTextStyleAttribute };
